import React, { useState } from "react";
import "../../components/CountryList/CountryList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const CountryList = ({ countryDetailResponse, setOpenProfile, openProfile }) => {
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Add a null check using the optional chaining operator (?.)
  const visibleData = countryDetailResponse?.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="container-fluid">
      <div className="countryList">
        <table>
          <thead>
            <tr className="countryListHeading">
              <th>S No.</th>
              <th>Country</th>
              <th>Country Code</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {visibleData?.length > 0 ? (
              visibleData.map((country, index) => (
                <tr key={country.id}>
                  <td>{startIndex + index + 1}</td>
                  <td>{country.name}</td>
                  <td>{country.code}</td>
                  <td>
                    <button
                      style={{
                        height: "35px",
                        width: "35px",
                        backgroundColor: "#F1F1F1",
                      }}
                      onClick={() => setOpenProfile(!openProfile)}
                    >
                      <EditOutlinedIcon className="icon" />
                    </button>
                    <button
                      style={{
                        height: "35px",
                        width: "35px",
                        marginLeft: "5px",
                        backgroundColor: "#F4616F",
                        borderColor: "#FF0000",
                      }}
                    >
                      <DeleteOutlinedIcon className="icon" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No data to display</td>
              </tr>
            )}
          </tbody>
        </table>
        <nav
          aria-label="Page navigation"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <ul className="pagination">
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {currentPage - 1}
              </a>
            </li>
            <li className="page-item active">
              <a className="page-link">{currentPage}</a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= countryDetailResponse?.length}
              >
                {currentPage + 1}
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= countryDetailResponse?.length}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default CountryList;
